import {
  Box,
  Button,
  Link,
  Typography,
} from '@mui/material'
import { useSelector } from '@xstate/react'
import mixpanel from 'mixpanel-browser'
import { useContext } from 'react'

import styles from 'src/components/Lmn/Lmn.scss'
import { LmnContext } from 'src/components/Dialogs/Lmn/LmnDialog'
import { CDN_PATH } from 'src/constants/global'
import { getLmnMerchantName, getLmnMerchantWebsite } from 'src/helpers/lmnHelpers'

const LmnAllSet = (): JSX.Element => {
  const { lmnContextService } = useContext(LmnContext)
  const { send } = lmnContextService
  const merchantName = useSelector(lmnContextService, getLmnMerchantName)
  const merchantWebsite = useSelector(lmnContextService, getLmnMerchantWebsite)

  const handleDoneClicked = (): void => {
    mixpanel.track('completed_lmn')
    send('ON_CANCEL')
  }
  return (
    <Box display="flex" flexDirection="column" gap="12px" alignItems="center" paddingTop="10px">
      <img src={`${CDN_PATH}/images/sika-check.svg`} alt="Heart with check" height="40" />
      <Typography variant="h4Bold" color="primary.main" marginTop="10px">
        Thank you!
      </Typography>
      <Typography variant="body3" color="gray1.main" textAlign="center">
        You will receive a text from our provider team within the next 12 hours to start
        your consultation.
      </Typography>
      <Typography variant="body3" color="gray1.main" textAlign="center">
        Based on their evaluation, the healthcare provider will determine whether to issue a
        Letter of Medical Necessity. If approved, please return to
        {' '}
        <Link
          href={merchantWebsite}
          color="primary"
          variant="body3"
          rel="noopener noreferrer"
          target="_blank"
        >
          {merchantName}
        </Link>
        {' '}
        to complete your purchase.
      </Typography>
      <Button
        className={styles.lmnButton}
        color="primary"
        fullWidth
        size="large"
        variant="contained"
        onClick={handleDoneClicked}
      >
        <Typography variant="body2Bold">
          Done
        </Typography>
      </Button>
    </Box>
  )
}

export default LmnAllSet
